import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Zmrznjen tsunami",
  "description": "",
  "published": "2007-01-31T00:00:00.000Z",
  "redirect_from": ["/blog/zmrznjen-tsunami/swizec/298"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ceprav`}<a parentName="p" {...{
        "href": "http://www.harkvideos.com/arctic.htm"
      }}>{` to`}</a>{` ni in ne more biti zmrznjen tsunami, je se vedno zelo zanimiv(o) za videti in opazovati.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      